import { Redirect } from 'react-router-dom';
import TopLevelRoutes from '../../routing/routes';

const GotoSessionExpired = () => <Redirect to={`${TopLevelRoutes.OTL}?expired"`} />;

export default GotoSessionExpired;
